/* eslint-disable react-refresh/only-export-components -- this module
 * intentionally pairs small inline icon components with the GLOBAL_NAV_ITEMS
 * data array they decorate; it's a shared constants module, not a
 * hot-reloadable component boundary. */
/**
 * Global navigation destinations — the six top-level sections of the app.
 * Shared between the icon rail (AppShell) and the command palette
 * (CommandBar) so both stay in sync with exactly one list, instead of two
 * copies drifting apart. Icons are 24-viewBox stroke glyphs (1.7 stroke,
 * round caps/joins) matching the app's existing icon convention
 * (IconProject/IconSettings in AppShell.tsx, the ProjectSidebar icon set).
 */
import type { ComponentType } from 'react';

export interface GlobalNavItem {
  id: string;
  label: string;
  path: string;
  Icon: ComponentType;
}

function IconDashboard() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="3" width="7.5" height="7.5" rx="1.6" />
      <rect x="13.5" y="3" width="7.5" height="7.5" rx="1.6" />
      <rect x="3" y="13.5" width="7.5" height="7.5" rx="1.6" />
      <rect x="13.5" y="13.5" width="7.5" height="7.5" rx="1.6" />
    </svg>
  );
}

function IconAccounts() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="7" width="18" height="13" rx="2" />
      <path d="M8 7V5.5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2V7" />
      <line x1="3" y1="13" x2="21" y2="13" />
    </svg>
  );
}

function IconSchedule() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="5" width="18" height="16" rx="2.2" />
      <line x1="3" y1="10" x2="21" y2="10" />
      <line x1="8" y1="2.5" x2="8" y2="6.5" />
      <line x1="16" y1="2.5" x2="16" y2="6.5" />
    </svg>
  );
}

function IconResources() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
}

function IconCapacity() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="5" y1="20" x2="5" y2="12" />
      <line x1="12" y1="20" x2="12" y2="5" />
      <line x1="19" y1="20" x2="19" y2="15" />
    </svg>
  );
}

function IconSupport() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="3.4" />
      <line x1="5.5" y1="5.5" x2="9.4" y2="9.4" />
      <line x1="14.6" y1="14.6" x2="18.5" y2="18.5" />
      <line x1="18.5" y1="5.5" x2="14.6" y2="9.4" />
      <line x1="9.4" y1="14.6" x2="5.5" y2="18.5" />
    </svg>
  );
}

export const GLOBAL_NAV_ITEMS: readonly GlobalNavItem[] = [
  { id: 'dashboard', label: 'Dashboard', path: '/', Icon: IconDashboard },
  { id: 'accounts', label: 'Accounts', path: '/accounts', Icon: IconAccounts },
  { id: 'schedule', label: 'Schedule', path: '/schedule', Icon: IconSchedule },
  { id: 'resources-calendar', label: 'Resources', path: '/resources-calendar', Icon: IconResources },
  { id: 'capacity', label: 'Capacity', path: '/workload', Icon: IconCapacity },
  { id: 'support', label: 'Support', path: '/support', Icon: IconSupport },
];
